import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import Accordion from "../../../accordion/index.js";
import { genKey } from "../../../../../../helpers/keys.js";
import * as S from "../../views/mobile/styled.js";
const AccordionMobile = (props)=>{
    const [formatedTabs, setFormatedTabs] = useState([]);
    useEffect(()=>{
        const newTabs = [];
        props.tabs.forEach((tab)=>{
            newTabs.push({
                content: tab.element ? /*#__PURE__*/ _jsx(_Fragment, {
                    children: tab.element
                }) : null,
                header: /*#__PURE__*/ _jsx(_Fragment, {
                    children: tab.label
                }),
                iconOpen: 'plus',
                iconClose: 'minus'
            });
        });
        setFormatedTabs(newTabs);
    }, [
        props.tabs
    ]);
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: formatedTabs.map((tab)=>/*#__PURE__*/ _jsx(S.AccordionWrapper, {
                children: /*#__PURE__*/ _jsx(Accordion, {
                    content: tab.content,
                    header: tab.header,
                    iconOpen: tab.iconOpen,
                    iconClose: tab.iconClose
                })
            }, genKey({
                tab: tab.header
            })))
    });
};
export default AccordionMobile;

//# sourceMappingURL=index.js.map